module.exports = __webpack_public_path__ + "static/maruya-067acd73d2f31e6fbcac488a2cad34e9.jpg";